import { initializeApp, getApps, getApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

// Safely read Vite env or fall back to user's Firebase project credentials
const metaEnv = (typeof import.meta !== 'undefined' && (import.meta as any).env) || {};

export const firebaseConfig = {
  apiKey: metaEnv.VITE_FIREBASE_API_KEY || "AIzaSyClhRGDOgzX3yA_wPAk2rriMi98ob7fZB4",
  authDomain: metaEnv.VITE_FIREBASE_AUTH_DOMAIN || "imotencentervarna-943c3.firebaseapp.com",
  projectId: metaEnv.VITE_FIREBASE_PROJECT_ID || "imotencentervarna-943c3",
  storageBucket: metaEnv.VITE_FIREBASE_STORAGE_BUCKET || "imotencentervarna-943c3.firebasestorage.app",
  messagingSenderId: metaEnv.VITE_FIREBASE_MESSAGING_SENDER_ID || "500824600855",
  appId: metaEnv.VITE_FIREBASE_APP_ID || "1:500824600855:web:f2c7f045f4551a4feec752",
  measurementId: metaEnv.VITE_FIREBASE_MEASUREMENT_ID || "G-K0Y2G15NRP"
};

// Initialize or reuse existing Firebase app
export const app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);
